import CorporateIcon from 'modules/Nav/icons/CorporateIcon'
import InstituteIcon from 'modules/Nav/icons/InstituteIcon'
import OnboardingIcon from 'modules/Nav/icons/OnboardingIcon'
import Systems from 'modules/Nav/icons/Systems'
import Users from 'modules/Nav/icons/Users'
import EventIcon from 'modules/Nav/icons/EventIcon'
import Speed from 'modules/Nav/icons/SpeedIcon'
import RankIcon from 'modules/Nav/icons/RankIcon'
import AssessmentIcon from 'modules/Nav/icons/AssessmentIcon'
import AdminDashboardIcon from 'modules/Nav/icons/AdminDashboardIcon'

/**
 * Strangler-fig: modules rebuilt in admin-react-v2 (a separate Next app served
 * at the SAME ORIGIN under /v2). Nav's click handler hard-navigates for any
 * /v2/* path — react-router can't client-route into another app.
 *
 * Which modules point at v2 depends on the ENVIRONMENT, not on the branch: an
 * env where admin-react-v2 isn't deployed must keep the legacy screen, because
 * nginx there has only `location /` and /v2/<x> would be served the v1 SPA,
 * which answers HTTP 200 and then renders PageNotFound. A dead nav item behind
 * a 200 is invisible to every health check — and corporate-react shipped
 * exactly that to UAT once by hand-editing the path on a branch.
 *
 * So the switch is `ADMIN_V2_MODULES` in that environment's own (gitignored)
 * .env: a comma-separated list of module keys that are live in v2 there, e.g.
 *
 *     export ADMIN_V2_MODULES='assessment,users'
 *
 * Unset/empty => every module stays on the legacy screen. Defaulting to the old
 * screen is the safe direction: worst case is a stale UI, not an unreachable one.
 *
 * The keys match `src/config/nav.tsx` in admin-react-v2, and the v2 route is
 * always `/v2/<key>` — keep both sides in step when adding a module.
 */
const V2_MODULES = new Set(
  (process.env.ADMIN_V2_MODULES || '')
    .split(',')
    .map(key => key.trim())
    .filter(Boolean)
)

const v2Path = (key, legacyPath) =>
  V2_MODULES.has(key) ? `/v2/${key}` : legacyPath

export const navItems = [
  // {
  //   path: '/dashboard',
  //   icon: DasgboardIcon,
  //   navTitle: 'Dashboard',
  //   pageTitle: 'Dashboard',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: v2Path('admin-dashboard', '/admin-dashboard'),
    icon: AdminDashboardIcon,
    navTitle: 'Admin Dashboard',
    pageTitle: 'Admin Dashboard',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('meta-dashboard', '/meta-dashboard'),
    icon: Speed,
    navTitle: 'Meta Dashboard',
    pageTitle: 'Meta Dashboard',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('onboarding', '/onboarding'),
    icon: OnboardingIcon,
    navTitle: 'Onboarding',
    pageTitle: 'Onboarding',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('corporates', '/corporates'),
    icon: CorporateIcon,
    navTitle: 'Corporates',
    pageTitle: 'Corporates',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('institutes', '/institutes'),
    icon: InstituteIcon,
    navTitle: 'Institutes',
    pageTitle: 'Institutes',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('assessment', '/assessment'),
    icon: AssessmentIcon,
    navTitle: 'Assessment',
    pageTitle: 'Assessment',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('feature-access', '/assessmentAccess'),
    icon: AssessmentIcon,
    navTitle: 'Feature Access',
    pageTitle: 'Feature Access',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/assessment',
  //   icon: AssessmentIcon,
  //   navTitle: 'Assessment',
  //   pageTitle: 'Assessment',
  //   menuType: 'GlobalMenu',
  // },
  // {
  //   path: '/exstudents',
  //   icon: ExStudents,
  //   navTitle: 'Talents/Ex-Stud.,',
  //   pageTitle: 'Talents/Ex-students',
  //   menuType: 'GlobalMenu',
  // },
  // {
  //   path: '/payments',
  //   icon: Payments,
  //   navTitle: 'Payments',
  //   pageTitle: 'Payments',
  //   menuType: 'GlobalMenu',
  // },
  {
        path: v2Path('analytics', '/dashboards'),
        icon: Systems,
        navTitle: 'Analytics',
        pageTitle: 'Analytics',
        menuType: 'GlobalMenu',
        subMenu: [
          {
            path: '',
            label: 'Dashboard',
            key: '/dashboards',
          },
          {
            path: '/candidate-metric-details',
            label: 'Candidates List',  
            key: '/candidate-metric-details',
          },
          // {
          //   path: '/candidate-metrics',
          //   label: 'Candidate Metrics',
          //   key: '/candidate-metrics',
          // },
          {
            path: '/candidates-raw',
            label: 'Ingested Sheets Logs',
            key: '/candidates-raw',
          },
        ],
  },
  {
    path: v2Path('reports', '/reports'),
    icon: Speed,
    navTitle: 'Reports',
    pageTitle: 'Reports',
    menuType: 'GlobalMenu',
    externalMenu: [
      {
        path: '/reports/corporate',
        icon: Systems,
        navTitle: 'Corporate',
        pageTitle: 'Reports',
        menuType: 'GlobalMenu',
        subMenu: [
          {
            path: '/',
            label: ' List of Corporate ',
            key: '/reports',
          },
          {
            path: '/empanelledinfotable',
            label: ' List of Corp. Empanelled',
            key: '/onboarding',
          },
          {
            path: '/top10index',
            label: 'Top/Bottom Corporate',
            key: '/onboarding',
          },
        ],
      },
      {
        path: '/reports/institute',
        icon: Systems,
        navTitle: 'Institutes',
        pageTitle: 'Reports',
        menuType: 'GlobalMenu',
        subMenu: [
          {
            path: '/',
            label: 'List of Institutes',
            key: '0',
          },
          {
            path: '/empanelledinfotable',
            label: ' List of Inst. Empanelled',
            key: '1',
          },

          {
            path: '/top10index',
            label: 'Top 10 Institutes',
            key: '3',
          },
        ],
      },
      {
        path: '/reports/students',
        icon: Systems,
        navTitle: 'Student',
        pageTitle: 'Student',
        menuType: 'GlobalMenu',
        subMenu: [
          {
            path: '/',
            label: 'List of Students',
            key: '5',
          },
          {
            path: '/listofstudentspalced',
            label: ' List of Students Placed',
            key: '6',
          },

          {
            path: '/studentplacedscoursewise',
            label: 'Stud. Placed-Course-Wise',
            key: '7',
          },
          {
            path: '/studentskillwise',
            label: 'Stud. Placed-Skill-Wise',
            key: '8',
          },
        ],
      },
      // {
      //   path: '/reports/admin',
      //   icon: Systems,
      //   navTitle: 'Admin',
      //   pageTitle: 'Admin',
      //   menuType: 'GlobalMenu',
      // },
    ],
  },
  {
    path: v2Path('users', '/users'),
    icon: Users,
    navTitle: 'Users',
    pageTitle: 'Users',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('system-config', '/systemConfig'),
    icon: Systems,
    navTitle: 'System Config',
    pageTitle: 'System Config',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('course-mapping', '/coursemapping'),
    icon: OnboardingIcon,
    navTitle: 'Course Mapping',
    pageTitle: 'Course Mapping',
    menuType: 'GlobalMenu',
  },
  {
    path: v2Path('event-catalogue', '/eventcatalogue'),
    icon: EventIcon,
    navTitle: 'Event Catalogue',
    pageTitle: 'Event Catalogue',
    menuType: 'GlobalMenu',
  },

  {
    path: v2Path('ranking-algorithm', '/rankingAlgorithm'),
    icon: RankIcon,
    navTitle: 'Rating Algorithm',
    pageTitle: 'Rating Algorithm',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/settings',
  //   icon: SettingIcon,
  //   navTitle: 'Settings',
  //   pageTitle: 'Settings',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/audit-log',
    icon: Systems,
    navTitle: 'Audit Log',
    pageTitle: 'Audit Log',
    menuType: 'GlobalMenu',
  },
]
